import { COUNTRIES } from '../../lib/constants';

interface Props {
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
  required?: boolean;
  label?: string;
  className?: string;
  /** Element id so an external <label htmlFor> can target this select. */
  id?: string;
}

export default function CountrySelect({ value, onChange, disabled, required, label, className = '', id }: Props) {
  return (
    <div className={className}>
      {label && <label className="block text-xs font-bold uppercase text-slate-500 mb-1.5">{label}{required && <span className="text-brand"> *</span>}</label>}
      <select
        id={id}
        disabled={disabled}
        required={required}
        value={value}
        onChange={e => onChange(e.target.value)}
        aria-label={label || 'Country'}
        className="w-full bg-white border border-slate-300 focus:border-brand focus:ring-1 focus:ring-brand-primary rounded-xl px-4 py-3 text-sm outline-none text-slate-800 font-medium shadow-sm"
      >
        <option value="">— Select Country —</option>
        {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}
      </select>
      {required && !value && <p className="text-caption text-rose-500 mt-1">Required</p>}
    </div>
  );
}
